import api from '@/utils/api.js'

/* 修改单门店商品
{
  nameID: id,
  unitPrice: price,
  isFocus: ,
  statusSaleBegin
  statusSaleEnd
  skus: [
    {
      skuID: id,
      isSale:
    }
  ]
}
*/
export const APIUpdateStoreSkus = async (json, noLoading = false) => {
  try {
    let res = await api('v2/store/sku/UpdateStoresSkus', {
      method: 'PUT',
      data: json,
      noLoading
    })
    return res
  } catch (e) {
    console.error(e)
    throw e
  }
}

/**
 * 获取门店商品
 * @param {*} json 查询条件
 */
export const APIGetStoresSkus = async (json, noLoading = true) => {
  try {
    const res = await api('v2/store/sku/GetStoresSkus', {
      params: json,
      noLoading
    })
    return res
  } catch (e) {
    console.error('APIGetStoresSkus', e)
    throw e
  }
}

/**
 * 获取门店商品审核列表
 * @param {*} json 数据
 * @param {*} noLoading no
 */
export const APIGetStoreSkuAudit = async (json, noLoading = true) => {
  try {
    const res = await api('v2/store/sku/GetStoreSkuAudit', {
      params: json,
      noLoading
    })
    return res
  } catch (e) {
    console.error('GetStoreSkuAudit', e)
    throw e
  }
}
//获取门店审核列表
export const APIGetStoreCheckList = async (json, noLoading = true) => {
  try {
    const res = await api('v2/store/GetStoreAudit', {
      params: json,
      noLoading
    })
    return res
  } catch (e) {
    console.error('GetStoreAudit', e)
    throw e
  }
}
/**
 * 处理门店商品审核
 * @param {*} query
 * @param {*} noLoading
 */
export const APIStoreSkuPriceAudit = async (query, noLoading = true) => {
  try {
    return await api('v2/store/sku/StoreSkuPriceAudit', {
      method: 'POST',
      data: query,
      noLoading
    })
  } catch (e) {
    console.error('APIStoreSkuPriceAudit', e)
    throw e
  }
}
/**
 * 处理门店审核
 * @param {*} query
 * @param {*} noLoading
 * paload :userID name 
 */
export const APIStoreAudit = async (query, noLoading = true) => {
  try {
    return await api('v2/store/StoreAudit', {
      method: 'POST',
      data: query,
      noLoading
    })
  } catch (e) {
    console.error('GetStoreAudit', e)
    throw e
  }
}
/**
 * 批量修改门店商品，不同步
 * @param {*} json 数据
 * @param {*} noLoading 不显示loading
 * storeIDs
 * payload
 *  payload=[{nameID, unitPrice, isFocus, isSale}]
 * isRefreshHigh
 */

export const APIUpdateStoresSkusWithoutSync = async (json, noLoading = true) => {
  try {
    return await api('v2/store/sku/UpdateStoresSkusWithoutSync', {
      method: 'PUT',
      data: json,
      noLoading
    })
  } catch (e) {
    throw e
  }
}

export const getStoresSkusSaleInfo = async (json, noLoading = true) => {
  try {
    return await api('v2/store/sku/GetStoresSkusSaleInfo', {
      method: 'GET',
      params: json,
      noLoading
    })
  } catch (e) {
    throw e
  }
}



// WEBPACK FOOTER //
// ./src/apis/APIstoreSku.js